<template>
  <div
    class="tw:max-w-md tw:flex tw:flex-col tw:gap-y-6"
    v-if="
      (selectedReasonObject !== null && (selectedReasonObject.id === 9 || selectedReasonObject.id === 10)) ||
      pauseType === 'permanent'
    "
  >
    <p v-html="$t('rc_set_to_inactive_info_text')" />
    <p v-html="$t('rc_pause_flow_support_cpc')" />
  </div>
  <div class="tw:max-w-md tw:flex tw:flex-col tw:gap-y-6" v-else>
    <p
      v-html="
        $t('rc_auto_resume_info_text', {
          StartDate: formatDate(resumeDate.fullDate),
        })
      "
    />
    <ul class="tw:list-disc tw:pl-6">
      <li v-for="(item, index) in items" :key="`item_${index}`">{{ $t(item) }}</li>
    </ul>

    <BankTransfer v-if="defaultPaymentMethod?.type === 'WIRE_TRANSFER'" @openPaymentPageSoonExpired="openPaymentPage" />
    <CardToExpire
      v-else-if="cardExpiresSoon && !isCardUpdated"
      :expirationDate="cardExpirationDate"
      :defaultPaymentMethod="defaultPaymentMethod"
      @openPaymentPageSoonExpired="openPaymentPage"
    />
    <CardExpired
      v-else-if="defaultPaymentMethod?.expired && !isCardUpdated"
      :expirationDate="cardExpirationDate"
      :defaultPaymentMethod="defaultPaymentMethod"
      @openPaymentPageSoonExpired="openPaymentPage"
    />

    <p>{{ $t('rc_pause_billing_info') }}</p>
  </div>
</template>
<script setup>
import { computed } from 'vue'

import CardToExpire from '@/components/rateConnect/pauseFlow/cpa/CardToExpire.vue'
import CardExpired from '@/components/rateConnect/pauseFlow/cpa/CardExpired.vue'
import BankTransfer from '@/components/rateConnect/pauseFlow/cpa/BankTransfer.vue'

import { useExistingPaymentMethods } from '@/components/payment/queries'
import { selectedAccommodationId } from '@/layouts/queries'
import { useRoute, useRouter } from 'vue-router'
import { useRateConnect } from '@/components/rateConnect/useRateConnect'

import appAnalytics from '@/utils/tracking'
import { useFormatting } from '@/composables/useFormatting'

const { togglePauseCampaign } = useRateConnect()
const { formatDate } = useFormatting()
const router = useRouter()
const route = useRoute()
const items = ['rc_auto_resume_info_1', 'rc_auto_resume_info_2', 'rc_auto_resume_info_3']
const isCardUpdated = computed(() => route.query?.isUpdated === 'true')

const props = defineProps({
  selectedReasonObject: [Object, null],
  selectedReason: String,
  otherExplanation: String,
  resumeDate: [Date, null],
  pauseType: {
    type: String,
    default: 'temporary',
    validator: value => ['temporary', 'permanent'].includes(value),
  },
})

const { existingPaymentMethods } = useExistingPaymentMethods(selectedAccommodationId)
const defaultPaymentMethod = computed(() => existingPaymentMethods.value?.find(item => item.isDefault))

const cardExpirationDate = computed(() => {
  const expMonth = defaultPaymentMethod.value?.expirationMonth
  const expYear = defaultPaymentMethod.value?.expirationYear
  if (!expMonth || !expYear) return null

  return new Date(expYear, expMonth, 0)
})

const cardExpiresSoon = computed(() => {
  if (!cardExpirationDate.value) return false

  const today = new Date()
  const msPerDay = 24 * 60 * 60 * 1000
  const daysUntilExpiration = Math.ceil((cardExpirationDate.value.getTime() - today.getTime()) / msPerDay)

  return daysUntilExpiration < 30 && daysUntilExpiration >= 0
})

const openPaymentPage = source => {
  appAnalytics.track(appAnalytics.events.RC_PAUSE_UNTIL_PAYMENT_INFO_ADD_PAYMENT_CLICKED, {
    accommodationId: selectedAccommodationId.value,
    campaignType: 'netcpa',
    source,
  })
  router.push({
    name: 'billing-edit-payment',
    query: { isPauseUntil: true, sourceRoute: router.currentRoute.value.name },
  })

  sessionStorage.setItem(
    'pauseFlowState',
    JSON.stringify({
      selectedReason: props.selectedReason,
      selectedReasonObj: props.selectedReasonObject,
      pauseType: props.pauseType,
      resumeDate: props.resumeDate,
      otherExplanation: props.otherExplanation,
      step: 2,
      hintsVisible: true,
      timestamp: Date.now(),
    })
  )
  togglePauseCampaign('close', false)
}
</script>
